/* eslint-disable import/no-cycle */
import { MarketplaceVendorsEntity } from '../../api/ORM/Schemas/marketplaceVendor.schema';

export interface MarketplaceVendorsDTO
  extends Omit<MarketplaceVendorsEntity, 'id' | 'created_at'> {
  id: number;
}

export enum MarketplaceVendorsCategory {
  'Accounting',
  'Banking',
  'Billing & Invoicing',
  'Payroll',
  'Expense Management',
  'Misc.',
}

export enum MarketplaceVendorsCategoryString {
  Accounting = 'Accounting',
  Banking = 'Banking',
  BillingInvoicing = 'Billing & Invoicing',
  Payroll = 'Payroll',
  ExpenseManagement = 'Expense Management',
  Misc = 'Misc.',
}
